/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const EqualResourceId: core.serialization.ObjectSchema<
    serializers.EqualResourceId.Raw,
    Truvity.EqualResourceId
> = core.serialization.object({
    value: core.serialization.string(),
});

export declare namespace EqualResourceId {
    export interface Raw {
        value: string;
    }
}
